import { ProductHistoryEventType } from "@/common/types";

/**
 * MED-653 — presentation helpers for the approval-history panel. The counts and
 * the headline are composed by the backend; only timestamps and raw field
 * values are formatted here.
 */

const DATE_TIME_OPTIONS: Intl.DateTimeFormatOptions = {
  day: "2-digit",
  month: "short",
  year: "numeric",
  hour: "2-digit",
  minute: "2-digit",
};

export function formatEventDate(value?: string | null) {
  if (!value) return "";
  const date = new Date(value);
  if (isNaN(date.getTime())) return "";

  return date.toLocaleDateString("en-GB", DATE_TIME_OPTIONS);
}

export function formatShortDate(value?: string | null) {
  if (!value) return "";
  const date = new Date(value);
  if (isNaN(date.getTime())) return "";

  return date.toLocaleDateString("en-GB");
}

/**
 * A changed field's before/after value. `from`/`to` arrive as string, number,
 * boolean or null, and an empty value has to read as "nothing was there" rather
 * than as a blank gap in the diff.
 */
export function formatChangeValue(value: string | number | boolean | null) {
  if (value === null || value === undefined || value === "") return "—";
  if (typeof value === "boolean") return value ? "Yes" : "No";

  return String(value);
}

/** Timeline dot/label colour per event type, keyed to the theme's text palette. */
export const EVENT_COLOR_KEY: Record<ProductHistoryEventType, string> = {
  submitted: "progress",
  resubmitted: "pending",
  approved: "life",
  declined: "danger",
  queried: "mild_danger",
  inventory_purged: "prim_100",
};

export function eventColorKey(eventType: ProductHistoryEventType) {
  return EVENT_COLOR_KEY[eventType] ?? "prim_100";
}
